export default "__VITE_ASSET__S6ibUPeo__"